// Public Service Desk portal shell. Brand-themed header + centered content.
// No auth — used for anonymous ticket submission and tokenized follow-up.
// Look & feel (title, logo, primary color) comes from the Service Desk
// appearance settings exposed via the public config endpoint.
import { useEffect, useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { brand } from "../../../config/theme";
import { getBrandLogo } from "../../../config/brandAssets";
import { useTheme } from "../../../context/ThemeContext";
import { getPublicConfig, type Appearance } from "../../../Layouts/service-desk/services/serviceDeskService";

export default function SoporteLayout() {
  const { isDarkMode } = useTheme();
  const [appearance, setAppearance] = useState<Appearance>({});

  useEffect(() => { getPublicConfig().then((c) => setAppearance(c.appearance || {})).catch(() => {}); }, []);

  const primary = appearance.primaryColor || brand.primary;
  const title = appearance.headerTitle || "Mesa de Servicio";

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-dark-bg" : "bg-gray-50"}`}>
      <header className={`border-b ${isDarkMode ? "border-dark-border bg-dark-surface" : "border-gray-200 bg-white"}`}>
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-3">
          <Link to="/map" className="flex items-center gap-3">
            <img src={appearance.logoUrl || getBrandLogo("main")} alt="Logo" className="h-8 w-auto" />
            <span className={`text-sm font-semibold ${isDarkMode ? "text-white" : "text-gray-700"}`}>{title}</span>
          </Link>
          <Link
            to="/soporte/seguimiento"
            className="text-sm font-medium hover:underline"
            style={{ color: primary }}
          >
            Seguir un ticket
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-4 py-8">
        <Outlet />
      </main>
      <footer className={`mx-auto max-w-4xl px-4 py-6 text-center text-xs ${isDarkMode ? "text-white/70" : "text-gray-400"}`}>
        © {new Date().getFullYear()} — {title}
      </footer>
    </div>
  );
}
